import { IEnvironment } from './models/environment.model';

const loginRedirectUrl =
  'https://v3staging.opstrax.com/api/id/accounts/' +
  'login?clientId={clientId}&ReturnUrl=https://v3staging.opstrax.com/login?successUri={route}';

export const environment: IEnvironment = {
  appId: 25,
  production: false,
  apiBaseUrl: 'https://v3staging.opstrax.com/api/traxpartners/',
  clientId: '099153c2625149bc8ecb3e85e03f0022',
  loginRedirectUrl: loginRedirectUrl,
  appIdDealer: 8,
  appIdShop: 14,
  users: [
    { name: 'bidt9', cfid: '6896:63b8137fb0fad75e-0BEF2A59-155D-0168-1378B828C18AE097' },
    { name: 'benderle', cfid: '2275:98e1d59c23b996e3-1E9142D6-155D-0168-1524BC52CD915FB3' },
    { name: 'admin', cfid: '2374:21f47fcff9abec3-D827B375-155D-0168-15AC907A776E041E' },
    { name: 'vtrax$16', cfid: '26:e95167c4670cd1d8-16DE476D-155D-0168-15387992454B1036' },
    { name: 'AndyReed', cfid: '2312:273aece007317a7b-B6739063-155D-0168-152DA3BCA4A9D282' },
    { name: 'areed', cfid: '2386:5e64e1c7665976ed-45EFCCAD-155D-001D-1169705F73F86B71'},
    { name: 'jennifer', cfid: '5702:1578d79c816455cb-067A9262-018E-C5CF-3AD452788AC8D6BC'},
  ],
  signalRHub: 'https://v3staging.opstrax.com/api/opspushnotification',
  product: 'staging1.traxpartners',
  logoutRedirectUrl: 'https://v3staging.opstrax.com/#/ops/',
  imagesFolderUrl: 'https://web1.opstrax.com/status/photos/',
  baseUrl: 'https://v3staging.opstrax.com/',
  thirdPartyAPI: 'https://v3staging.opstrax.com/api/thirdpartyapi/',
  commonAPI: 'https://v3staging.opstrax.com/api/opscommonapi/',
  ruleEngineUrl: 'https://v3staging.opstrax.com/api/opsruleengine/',
  awsEndpoint: 'https://s3-us-west-1.amazonaws.com/profile-images.ops.staging1/',
  environment: 'staging1',
  googleApiKey: 'AIzaSyCB09nNI8BGZzrXix86yshCsj0zv07uDgw',
  uiSentryDsn: 'https://f97b6a93466242b89eb431959078fded@o221377.ingest.sentry.io/1369717',
  identityApiBaseUrl: 'https://v3staging.opstrax.com/api/id/',
  supportLinkShop: 'https://traxshop.zendesk.com/hc/categories/12987695814035',
  supportLinkSupplier: 'https://traxsupplier.zendesk.com/hc/categories/12987797236627',
  walkMeConfigUrl: 'https://cdn.walkme.com/users/49eb3bd669cc49ab9a5eeee287d01357/test/walkme_49eb3bd669cc49ab9a5eeee287d01357_https.js',
  oecLogoutUrl: 'https://accountna.oecdev.oeconnection.com/auth/realms/NA/protocol/openid-connect/logout',
  supplierServiceBaseUrl: 'https://v3staging.opstrax.com/api/supplier/',
  assetsEndpoint: 'https://assets.development.opstrax.com/',
  datadogRum: {
    applicationId: 'bf67de2d-25f4-46bf-ba43-afbd106b9f1e',
    clientToken: 'pub762c467adb025844a4084f7f3406c5f4',
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'allow',
  },
};
